export default "__VITE_ASSET__ClzcX6kr__"